import type { ReactNode } from 'react';

import { usePresence } from './motion';

/**
 * A disclosure that opens and closes by height. The children mount when `open` turns true
 * and stay mounted while the panel closes, so the content is still there to slide away.
 * Height is animated through a grid track (0fr → 1fr), which every engine interpolates.
 */
export function Reveal({
  open,
  children,
  className,
}: {
  open: boolean;
  children: ReactNode;
  className?: string;
}) {
  const { present, ref } = usePresence<HTMLDivElement>(open);
  if (!present) return null;
  return (
    <div
      ref={ref}
      className={['reveal', className].filter(Boolean).join(' ')}
      data-open={open || undefined}
    >
      <div>{children}</div>
    </div>
  );
}
